<div id="layout-wrapper">
    <app-topbar> </app-topbar>
    <app-sidebar></app-sidebar>
    <div class="main-content">
        <div class="page-content">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>